'use client';
import { useMedia } from 'react-use';
import { useVipStateWithCache } from '~/common/hooks/use-vip-state-with-cache';
import { Breakpoints } from '~/utils/styles/enums';
import { MobileOverlayAd } from './mobile-overlay-ad';
import { MobileOverlayAdWithAdx } from './mobile-overlay-ad-with-adx';
import { PCOverlayAd } from './pc-overlay-ad';

type Props = {
  canShowGoogleAd: boolean;
};

export const IMobileOverlayContainer = ({ canShowGoogleAd }: Props) => {
  const { storedVipState } = useVipStateWithCache();
  const screenLarge = useMedia(`(min-width: ${Breakpoints.md})`, undefined);
  const isMobile =
    typeof screenLarge === 'undefined' ? undefined : !screenLarge;

  const disableAd =
    isMobile === undefined || storedVipState || typeof window === 'undefined';

  // 広告を表示させないとき
  if (disableAd) return null;

  return (
    <>
      {isMobile ? (
        canShowGoogleAd ? (
          <MobileOverlayAdWithAdx />
        ) : (
          <MobileOverlayAd canShowGoogleAd={canShowGoogleAd} />
        )
      ) : (
        <PCOverlayAd canShowGoogleAd={canShowGoogleAd} />
      )}
    </>
  );
};
